<template>
  <v-main style="padding: 0;">
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      :label="$t('common.search')"
      single-line
      hide-details
      style="margin: 0rem 2rem;"
    ></v-text-field>

    <v-data-table
      :headers="headers"
      :items="devices"
      :loading="status.loading"
      :items-per-page="50"
      class="elevation-1"
      :search="search"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn icon color="primary" @click="handleClick(item.deviceId)">
          <v-icon>mdi-hand-right</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          {{ $t("common.verify") }}
        </v-card-title>
        <v-card-text v-if="authorize(Roles.AdminOrSuper)">
          <v-autocomplete
            autocomplete="off"
            prepend-icon="mdi-company"
            :label="$t('company.name')"
            v-model="company"
            :items="companies"
            item-text="companyName"
            item-value="companyId"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="accent darken-1" text @click="dialogClose(false)">{{
            $t("common.no")
          }}</v-btn>
          <v-btn color="primary darken-1" text @click="dialogClose(true)">{{
            $t("common.yes")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "DevicePool",

  data() {
    return {
      search: "",
      dialog: false,
      device: null,
      company: null,
      headers: [
        { text: this.$t("device.serialNumber"), value: "serialNumber" },
        { text: this.$t("device.imei"), value: "imei" },
        { text: this.$t("device.productName"), value: "productName" },
        { text: "", value: "actions" }
      ]
    };
  },

  computed: {
    ...mapState("devices", { devices: "pool", status: "status" }),
    ...mapState("companies", { companies: "companies" })
  },

  methods: {
    ...mapActions("devices", ["getPool", "setPool"]),
    ...mapActions("companies", { getCompanies: "getAll" }),

    handleClick(deviceId) {
      this.device = deviceId;
      this.dialog = true;
    },

    async dialogClose(value) {
      if (!value) {
        this.dialog = false;
        return;
      }
      // Change the device to the company
      this.dialog = false;
      await this.setPool({ deviceId: this.device, companyId: this.company });
      await this.getPool();
    },

    getColorFromBool(val) {
      return val ? "success" : "error";
    }
  },

  async created() {
    await this.getPool();
    if (this.authorize(this.Roles.AdminOrSuper)) {
      await this.getCompanies();
    } else {
      this.$router.push("/");
    }
  }
};
</script>
